import { defaultFills } from './Colors';
export type Intents = 'none' | 'success' | 'warning' | 'info' | 'danger';

export const getColorFromIntent = (intent: Intents): string => {
  if (intent === 'none') return defaultFills.normal[500];
  else return defaultFills[intent][500];
};

export const getTintFromIntent = (intent: Intents) => {
  if (intent === 'none') return defaultFills.normal[100];
  if (intent === 'info') return defaultFills.info[100];
  if (intent === 'success') return defaultFills.success[100];
  if (intent === 'warning') return defaultFills.warning[100];
  if (intent === 'danger') return defaultFills.danger[100];
};
